import { MouseEvent } from 'react';

import { UserSubscription } from '../../../../types/subscription.type';
import SubscriptionRow from '../subscription-row/subscription-row';

import styles from './subscriptions-table.module.scss';

type Props = {
    subscriptions: UserSubscription[];
    onSelect: (ev: MouseEvent, id: number) => void;
};

const HEADERS = [
    'Plan',
    'Suspendida desde',
    'Frecuencia',
    'Vencimiento',
    'Compañía',
];

const SubscriptionsTable = ({ subscriptions, onSelect }: Props) => {
    return (
        <table className={styles.table}>
            <thead>
                <tr>
                    {HEADERS.map((header) => (
                        <th key={`header-${header}`}>
                            <span>{header}</span>
                        </th>
                    ))}
                    <th style={{ width: '100%' }}>
                        <span />
                    </th>
                </tr>
            </thead>
            <tbody>
                {subscriptions.map((subscription) => (
                    <SubscriptionRow
                        key={subscription.id}
                        subscription={subscription}
                        onDetails={onSelect}
                    />
                ))}
            </tbody>
        </table>
    );
};

export default SubscriptionsTable;
